import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux'
import {
    registrarSolicitudFC_41Accion,
    guardarCambiosFC_41Solicitud,
    actualizarFC_41Estatus,
    agregarFC_41AnexoProducto,
    agregarMapFC_41Accion,
    agregarMapAnexosFC_41Accion,
    obtenerIdCliente,
    actualizarFC_41MapSolicitud, actualizarFC_41Solicitud,
    obtenerFC_41SolicitudDetalle, generarDocumentosFC_41,
    actualizarFC_41SolicitudModal
} from '../../../redux/DucksAtencionACliente/FC_41AtencionAClienteDucks'
import { AcualizarFormatoAccion } from '../../../redux/AtencionAClienteDucks'
import { host } from '../../../configuraciones'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilosFC41 from './AtencionAClientesFC_41Component.module.css'; { {/*Estilos para el componente*/ } }
const { useState, useEffect, useRef } = React;
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import Tooltip from '@mui/material/Tooltip';
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 550,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import ModalDetalleProducto from './ModalDetalleProducto';
import FormularioDocumentacionFC_41 from './FormularioDocumentacionFC_41';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

function FC_41Component(props) {
    const dispatch = useDispatch()

    var fechaHoy = moment().format('YYYY-MM-DD');
    let fc_41 = useSelector(store => store.FC_41SolicitudAtencionACliente.fc_41)
    let fc_41Productos = useSelector(store => store.FC_41SolicitudAtencionACliente.productos)
    let fc_41Map = useSelector(store => store.FC_41SolicitudAtencionACliente.fc_41Map)
    let fc_41ProductosMap = useSelector(store => store.FC_41SolicitudAtencionACliente.productosMap)
    let filesProductosMap = useSelector(store => store.FC_41SolicitudAtencionACliente.filesProductosMap)
    const currentUser = useSelector(store => store.Usuario.data)
    const modoEdicionBorrador = useSelector(store => store.FC_41SolicitudAtencionACliente.modoEdicionBorrador)
    let solicitud = useSelector(store => store.FC_41SolicitudAtencionACliente.data)
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    const dataUser = useSelector(store => store.Usuario.user)

    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Características de productos', 'Documentación'])

    const modoVerDetalle = useSelector(store => store.FC_41SolicitudAtencionACliente.modoVerDetalle)
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }

    let domicilio = ''
    if (solicitud.tipoinstalacion == 'Otro') {
        let numerointerior = ''
        let numeroexterior = ''
        let colonia = ''
        let calle = ''
        if (solicitud.colonia != '') colonia = solicitud.colonia
        if (solicitud.numerointerior != '') numerointerior = solicitud.numerointerior
        else numerointerior = 's/n'
        if (solicitud.numeroexterior != '') numeroexterior = solicitud.numeroexterior
        else numeroexterior = 's/n'
        if (solicitud.calle == 'Otro') calle = solicitud.otracalle
        else calle = solicitud.calle
        domicilio = calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' + colonia + ', ' + solicitud.localidad + ', ' +
            solicitud.municipioalcaldia + ', ' + solicitud.estado + ', ' + solicitud.codigopostal
    } else {
        domicilio = solicitud.domicilio
    }
    let pagina1 = []
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: 'Unidad de envasado', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.tipoinstalacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.tipoinstalacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.tipoinstalacioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Nombre del responsable', valor: solicitud.responsableinstalaciones, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.responsableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.responsableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.responsableinstalacionescheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio completo', valor: domicilio, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.domicilio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.domiciliocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.domiciliocheck : false,
        },
    )
    if (solicitud.entregahologramasbebidasmezcal) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Entrega de hologramas para bebidas con mezcal', valor: solicitud.entregahologramasbebidasmezcal ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.entregahologramasbebidasmezcal : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.entregahologramasbebidasmezcalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.entregahologramasbebidasmezcalcheck : false,
            },
        )
    }
    if (solicitud.inspeccionduranteenvasado) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Inspección durante el envasado', valor: solicitud.inspeccionduranteenvasado ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.inspeccionduranteenvasado : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.inspeccionduranteenvasadocheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.inspeccionduranteenvasadocheck : false,
            },
        )
    }
    if (solicitud.emicioncertificadonomexportacio) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Emisión del certificado NOM de exportación', valor: solicitud.emicioncertificadonomexportacio ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.emicioncertificadonomexportacio : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.emicioncertificadonomexportaciocheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.emicioncertificadonomexportaciocheck : false,
            },
        )
    }
    if (solicitud.emicioncertificadonomnacional) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Emisión del certificado NOM para venta nacional', valor: solicitud.emicioncertificadonomnacional ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.emicioncertificadonomnacional : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.emicioncertificadonomnacionalcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.emicioncertificadonomnacionalcheck : false,
            },
        )
    }
    pagina1.push({
        id: uuidv4(), Campo: 'Fecha propuesta de la actividad', valor: solicitud.fechavisitapropuesta.substring(0, 10), idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.fechavisitapropuesta : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.fechavisitapropuestacheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.fechavisitapropuestacheck : false,
    })
    if (solicitud.ventanacional) {
        pagina1.push({
            id: uuidv4(), Campo: 'Venta nacional', valor: solicitud.ventanacional ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.ventanacional : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.ventanacionalcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.ventanacionalcheck : false,
        })
    }
    if (solicitud.ventaexportacion) {
        pagina1.push({
            id: uuidv4(), Campo: 'Venta exportación', valor: solicitud.ventaexportacion ? 'Si' : 'No', idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.ventaexportacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.ventaexportacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.ventaexportacioncheck : false,
        })
        pagina1.push({
            id: uuidv4(), Campo: 'Nombre de importador', valor: solicitud.nombreimportador, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.nombreimportador : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.nombreimportadorcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.nombreimportadorcheck : false,
        })
        pagina1.push({
            id: uuidv4(), Campo: 'Domicilio del importador', valor: solicitud.domicilioimportador, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.domicilioimportador : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.domicilioimportadorcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.domicilioimportadorcheck : false,
        })
        pagina1.push({
            id: uuidv4(), Campo: 'Pais destino', valor: solicitud.paisdestino, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.paisdestino : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.paisdestinocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.paisdestinocheck : false,
        })
        pagina1.push({
            id: uuidv4(), Campo: 'Aduana salida', valor: solicitud.aduanasalida, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.aduanasalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.aduanasalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.aduanasalidacheck : false,
        })
        pagina1.push({
            id: uuidv4(), Campo: 'Observaciones', valor: solicitud.observaciones, idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.observaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? !fc_41Map?.observacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_41Map) && JSON.stringify([]) !== JSON.stringify(fc_41Map) ? fc_41Map?.observacionescheck : false,
        })
    }

    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)

    let pagina2 = []
    let pagina3 = []
    for (const i in solicitud.fc_41_anexoproducto) {
        const { ...producto } = solicitud.fc_41_anexoproducto[i]
        let filtro = fc_41ProductosMap?.filter(anexo => anexo?.idfc41_anexoproducto === producto?.idfc41_anexoproducto)
        pagina2.push({
            id: uuidv4(), idfc41_anexoproducto: producto.idfc41_anexoproducto,
            idfc41_anexoproductomap: filtro[0]?.idfc41_anexoproductomap ? filtro[0]?.idfc41_anexoproductomap : '',
            marca: producto.marca,
            tipobebida: producto.tipobebida,
            numeroanalisisgranel: producto.numeroanalisisgranel,
            numeroanalisisbebida: producto.numeroanalisisbebida,
            numerocertificado: producto.numerocertificado,
            numerolote: producto.numerolote,
            numerolotegranel: producto.numerolotegranel,
            contenidoalcoholico: producto.contenidoalcoholico,
            unidad: producto.unidad,
            ingrediente: producto.ingrediente,
            contenidonetobotella: producto.contenidonetobotella,
            numerobotellas: producto.numerobotellas,
            numerocajas: producto.numerocajas,
            observaciones: filtro[0] ? filtro[0].producto : '',
            correcto: filtro[0] ? !filtro[0].productocheck : false,
            incorrecto: filtro[0] ? filtro[0].productocheck : false,
        })
        let numero = Number(i) + 1
        pagina3.push({ id: uuidv4(), nameDoc: 'Producto ' + numero + ' ' + producto.tipobebida })
        let cortegranel = solicitud.fc_41_anexoproducto[i].numeroanalisisgranel.split(',')
        for (const id in cortegranel) {
            let nameidAnaGranel = `DPAG${i}${id}`
            const filtroGranel = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPAG${i}${id}`))
            const filtroMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtroGranel?.[0]?.idfc_41archivoproducto)
            pagina3.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0]?.observacion ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap?.[0]?.estatuscheck : false,
                fechaInicio: filtroGranel?.[0]?.fechainicio ? filtroGranel?.[0]?.fechainicio : '',
                fechaTermino: filtroGranel?.[0]?.fechafin ? filtroGranel?.[0]?.fechafin : '',
                estatus: filtroGranel?.[0]?.estatus ? filtroGranel?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_41archivoproductomap : '',
                idfc_41archivoproducto: filtroGranel?.[0]?.idfc_41archivoproducto,
                tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
                nameid: `DPAG${i}${id}`, nameDoc: 'Análisis de laboratorio a granel del mezcal: ' + cortegranel[id]
            })
        }

        let nameidNOM = `DPCN${i}`
        const filtroNOM = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPCN`))
        const filtroNOMMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtroNOM?.[0]?.idfc_41archivoproducto)
        pagina3.push({
            id: uuidv4(),
            observaciones: filtroNOMMap?.[0]?.observacion ? filtroNOMMap?.[0]?.observacion : '',
            correcto: filtroNOMMap?.[0] ? !filtroNOMMap?.[0]?.estatuscheck : false,
            incorrecto: filtroNOMMap?.[0] ? filtroNOMMap?.[0]?.estatuscheck : false,
            fechaInicio: filtroNOM?.[0]?.fechainicio ? filtroNOM?.[0]?.fechainicio : '',
            fechaTermino: filtroNOM?.[0]?.fechafin ? filtroNOM?.[0]?.fechafin : '',
            estatus: filtroNOM?.[0]?.estatus ? filtroNOM?.[0]?.estatus : 'Agregar',
            idMap: filtroNOMMap?.[0] ? filtroNOMMap?.[0]?.idfc_41archivoproductomap : '',
            idfc_41archivoproducto: filtroNOM?.[0]?.idfc_41archivoproducto,
            tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
            nameid: `DPCN${i}`, nameDoc: 'Certificado NOM a granel vigente del mezcal'
        })
        let cortebebida = solicitud.fc_41_anexoproducto[i].numeroanalisisbebida.split(',')
        for (const id in cortebebida) {
            let nameidAnaBebida = `DPAB${i}${id}`
            const filtroBebida = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPAB${i}${id}`))
            const filtroBebidaMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtroBebida?.[0]?.idfc_41archivoproducto)
            pagina3.push({
                id: uuidv4(),
                observaciones: filtroBebidaMap?.[0]?.observacion ? filtroBebidaMap?.[0]?.observacion : '',
                correcto: filtroBebidaMap?.[0] ? !filtroBebidaMap?.[0]?.estatuscheck : false,
                incorrecto: filtroBebidaMap?.[0] ? filtroBebidaMap?.[0]?.estatuscheck : false,
                fechaInicio: filtroBebida?.[0]?.fechainicio ? filtroBebida?.[0]?.fechainicio : '',
                fechaTermino: filtroBebida?.[0]?.fechafin ? filtroBebida?.[0]?.fechafin : '',
                estatus: filtroBebida?.[0]?.estatus ? filtroBebida?.[0]?.estatus : 'Agregar',
                idMap: filtroBebidaMap?.[0] ? filtroBebidaMap?.[0]?.idfc_41archivoproductomap : '',
                idfc_41archivoproducto: filtroBebida?.[0]?.idfc_41archivoproducto,
                tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
                nameid: `DPAB${i}${id}`, nameDoc: 'Análisis de laboratorio de % Alc. Vol.de la bebida con mezcal: ' + cortebebida[id]
            })
        }

        if (solicitud.ventaexportacion) {
            let nameidOrden = `DPOC${i}`
            const filtroorden = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPOC`))
            const filtroOrdenMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtroorden?.[0]?.idfc_41archivoproducto)
            pagina3.push({
                id: uuidv4(),
                observaciones: filtroOrdenMap?.[0]?.observacion ? filtroOrdenMap?.[0]?.observacion : '',
                correcto: filtroOrdenMap?.[0] ? !filtroOrdenMap?.[0]?.estatuscheck : false,
                incorrecto: filtroOrdenMap?.[0] ? filtroOrdenMap?.[0]?.estatuscheck : false,
                fechaInicio: filtroorden?.[0]?.fechainicio ? filtroorden?.[0]?.fechainicio : '',
                fechaTermino: filtroorden?.[0]?.fechafin ? filtroorden?.[0]?.fechafin : '',
                estatus: filtroorden?.[0]?.estatus ? filtroorden?.[0]?.estatus : 'Agregar',
                idMap: filtroOrdenMap?.[0] ? filtroOrdenMap?.[0]?.idfc_41archivoproductomap : '',
                idfc_41archivoproducto: filtroorden?.[0]?.idfc_41archivoproducto,
                tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
                nameid: `DPOC${i}`, nameDoc: 'Orden de compra del importador'
            })
            let nameidFactura = `DPFP${i}`
            const filtrofactura = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPFP`))
            const filtroFacturaMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtrofactura?.[0]?.idfc_41archivoproducto)
            pagina3.push({
                id: uuidv4(),
                observaciones: filtroFacturaMap?.[0]?.observacion ? filtroFacturaMap?.[0]?.observacion : '',
                correcto: filtroFacturaMap?.[0] ? !filtroFacturaMap?.[0]?.estatuscheck : false,
                incorrecto: filtroFacturaMap?.[0] ? filtroFacturaMap?.[0]?.estatuscheck : false,
                fechaInicio: filtrofactura?.[0]?.fechainicio ? filtrofactura?.[0]?.fechainicio : '',
                fechaTermino: filtrofactura?.[0]?.fechafin ? filtrofactura?.[0]?.fechafin : '',
                estatus: filtrofactura?.[0]?.estatus ? filtrofactura?.[0]?.estatus : 'Agregar',
                idMap: filtroFacturaMap?.[0] ? filtroFacturaMap?.[0]?.idfc_41archivoproductomap : '',
                idfc_41archivoproducto: filtrofactura?.[0]?.idfc_41archivoproducto,
                tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
                nameid: `DPFP${i}`, nameDoc: 'Factura o proforma'
            })
        }
        let nameidJuego = `DPJE${i}`
        const filtroJuego = solicitud.fc_41_anexoproducto[i].fc_41archivoproducto.filter(anexo => (anexo.nameid).includes(`DPJE`))
        const filtroJuegoMap = filesProductosMap?.filter(anexo => anexo?.idfc_41archivoproducto === filtroJuego?.[0]?.idfc_41archivoproducto)
        pagina3.push({
            id: uuidv4(),
            observaciones: filtroJuegoMap?.[0]?.observacion ? filtroJuegoMap?.[0]?.observacion : '',
            correcto: filtroJuegoMap?.[0] ? !filtroJuegoMap?.[0]?.estatuscheck : false,
            incorrecto: filtroJuegoMap?.[0] ? filtroJuegoMap?.[0]?.estatuscheck : false,
            fechaInicio: filtroJuego?.[0]?.fechainicio ? filtroJuego?.[0]?.fechainicio : '',
            fechaTermino: filtroJuego?.[0]?.fechafin ? filtroJuego?.[0]?.fechafin : '',
            estatus: filtroJuego?.[0]?.estatus ? filtroJuego?.[0]?.estatus : 'Agregar',
            idMap: filtroJuegoMap?.[0] ? filtroJuegoMap?.[0]?.idfc_41archivoproductomap : '',
            idfc_41archivoproducto: filtroJuego?.[0]?.idfc_41archivoproducto,
            tabla: 'fc_41archivoproducto', nombreId: 'idfc41_anexoproducto', idSolicitud: producto.idfc41_anexoproducto,
            nameid: `DPJE${i}`, nameDoc: 'Juego de etiquetas aprobadas por COMERCAM'
        })
    }
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)
    let [rowspagina3, setRowsPagina3] = React.useState(pagina3)
    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroProducto = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina3.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroProducto !== -1) {
            rowspagina2[filtroProducto].valor = objectProducto.valor
            rowspagina2[filtroProducto].correcto = objectProducto.correcto
            rowspagina2[filtroProducto].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroProducto].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            //rowspagina2[filtroDocumentacion].valor = objectProducto.valor
            rowspagina3[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina3[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina3[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }
    const columns = [
        {
            field: 'tipobebida', headerName: 'Tipo de bebida', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.tipobebida}`} arrow>
                    <label>{`${params.row.tipobebida} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'marca', headerName: 'Marca', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.marca}`} arrow>
                    <label>{`${params.row.marca} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'numeroanalisisgranel', headerName: 'No. de análisis granel', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 170,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.numeroanalisisgranel}`} arrow>
                    <label>{`${params.row.numeroanalisisgranel} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 170,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                    <label>{`${params.row.contenidoalcoholico} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'numerolote', headerName: 'No. de lote envasado', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.numerolote}`} arrow>
                    <label>{`${params.row.numerolote} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'detalle', headerName: 'Detalle', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 140,
            renderCell: (params) => (
                <Fragment>
                    <button className={`btn btn-outline-secondary ms-1`} onClick={() => { setDataDetalle(params.row), setDetalleMarcas(true) }} >Detalle</button>
                </Fragment>

            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilosFC41.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) => (
                <Fragment>
                    <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                    <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                </Fragment>
            )
        },
    ]
    const [detalleMarcas, setDetalleMarcas] = React.useState(false)
    const [dataDetalle, setDataDetalle] = React.useState([])
    const VerModalDetalle = (objeto) => {
        setDetalleMarcas(objeto)
    }

    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            <div className="form-floating mb-3" color='black'>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} />
                                {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                <label htmlFor="floatingInput">Campo</label>
                            </div>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />

                        </Typography>
                        <br />

                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilosFC41.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />

                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilosFC41.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_41Map) || JSON.stringify([]) === JSON.stringify(fc_41Map) || fc_41Map === null) {
            await agregarMapYActualizarFC_41()
            const idSolicitud = solicitud.idfc41_solicitudparabebidasconm
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_41 = 12
            const tabla = tablaFC_41
            await dispatch(actualizarFC_41Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_41()
            const idSolicitud = solicitud.idfc41_solicitudparabebidasconm
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_41 = 12
            const tabla = tablaFC_41
            await dispatch(actualizarFC_41Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_41 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc41_solicitudparabebidasconm: rowspagina1[0].idfc41_solicitudparabebidasconm,
            responsableinstalaciones: rowspagina1[1].valor,
            correoelectronico: rowspagina1[2].valor, telefono: rowspagina1[3].valor,
            domicilio: rowspagina1[4].valor, fechasolicitud: fechaSolicitudAceptada
        })
        let principalMap = []
        principalMap.push({
            tipoinstalacion: rowspagina1[0].observaciones,
            responsableinstalaciones: rowspagina1[1].observaciones,
            correoelectronico: rowspagina1[2].observaciones,
            telefono: rowspagina1[3].observaciones,
            domicilio: rowspagina1[4].observaciones,

            tipoinstalacioncheck: rowspagina1[0].incorrecto,
            responsableinstalacionescheck: rowspagina1[1].incorrecto,
            correoelectronicocheck: rowspagina1[2].incorrecto,
            telefonocheck: rowspagina1[3].incorrecto,
            domiciliocheck: rowspagina1[4].incorrecto,
            idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
        })
        for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Entrega de hologramas para bebidas con mezcal') principalMap.push({ entregahologramasbebidasmezcal: rowspagina1[i].observaciones, entregahologramasbebidasmezcalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Inspección durante el envasado') principalMap.push({ inspeccionduranteenvasado: rowspagina1[i].observaciones, inspeccionduranteenvasadocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Emisión del certificado NOM de exportación') principalMap.push({ emicioncertificadonomexportacio: rowspagina1[i].observaciones, emicioncertificadonomexportaciocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Emisión del certificado NOM para venta nacional') principalMap.push({ emicioncertificadonomnacional: rowspagina1[i].observaciones, emicioncertificadonomnacionalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Fecha propuesta de la actividad') principalMap.push({ fechavisitapropuesta: rowspagina1[i].observaciones, fechavisitapropuestacheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Venta nacional') principalMap.push({ ventanacional: rowspagina1[i].observaciones, ventanacionalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Venta exportación') principalMap.push({ ventaexportacion: rowspagina1[i].observaciones, ventaexportacioncheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Nombre de importador') principalMap.push({ nombreimportador: rowspagina1[i].observaciones, nombreimportadorcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Domicilio del importador') principalMap.push({ domicilioimportador: rowspagina1[i].observaciones, domicilioimportadorcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Pais destino') principalMap.push({ paisdestino: rowspagina1[i].observaciones, paisdestinocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Aduana salida') principalMap.push({ aduanasalida: rowspagina1[i].observaciones, aduanasalidacheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Observaciones') principalMap.push({ observaciones: rowspagina1[i].observaciones, observacionescheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let productosMap = []
        for (const producto of rowspagina2) {
            productosMap.push({ producto: producto.observaciones, productocheck: producto.incorrecto, idfc41_anexoproducto: producto.idfc41_anexoproducto })
        }
        let archivosProductosMap = []
        for (const anexo in rowspagina3) {
            let nameid = rowspagina3[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAG" || nameid === "DPAB" || nameid === "DPFP" || nameid == "DPOC" || nameid == "DPCN" || nameid == "DPJE") {
                archivosProductosMap.push({
                    estatuscheck: rowspagina3[anexo]?.incorrecto, observacion: rowspagina3[anexo]?.observaciones,
                    idfc_41archivoproducto: rowspagina3[anexo]?.idfc_41archivoproducto,
                })
            }
        }

        let archivosProductos = []
        for (const anexo in rowspagina3) {
            let nameid = rowspagina3[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAG" || nameid === "DPAB" || nameid === "DPFP" || nameid == "DPOC" || nameid == "DPCN" || nameid == "DPJE") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina3[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina3[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina3[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina3[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_41archivoproducto: rowspagina3[anexo]?.idfc_41archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosProductos: archivosProductos }

        let formatoMap = { solicitud: obj_unidos, productosMap: productosMap, archivosProductosMap: archivosProductosMap }
        await dispatch(agregarMapFC_41Accion(formatoMap))
        await dispatch(actualizarFC_41Solicitud(formato))
        return
    }

    const actualizarMapYActualizarFC_41 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc41_solicitudparabebidasconm: rowspagina1[0].idfc41_solicitudparabebidasconm,
            responsableinstalaciones: rowspagina1[1].valor,
            correoelectronico: rowspagina1[2].valor, telefono: rowspagina1[3].valor,
            domicilio: rowspagina1[4].valor, fechasolicitud: fechaSolicitudAceptada
        })
        let principalMap = []
        principalMap.push({
            idfc41_solicitudparabebidasconmmap: fc_41Map.idfc41_solicitudparabebidasconmmap,
            tipoinstalacion: rowspagina1[0].observaciones,
            responsableinstalaciones: rowspagina1[1].observaciones,
            correoelectronico: rowspagina1[2].observaciones,
            telefono: rowspagina1[3].observaciones,
            domicilio: rowspagina1[4].observaciones,

            tipoinstalacioncheck: rowspagina1[0].incorrecto,
            responsableinstalacionescheck: rowspagina1[1].incorrecto,
            correoelectronicocheck: rowspagina1[2].incorrecto,
            telefonocheck: rowspagina1[3].incorrecto,
            domiciliocheck: rowspagina1[4].incorrecto,
            idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
        })
        for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Entrega de hologramas para bebidas con mezcal') principalMap.push({ entregahologramasbebidasmezcal: rowspagina1[i].observaciones, entregahologramasbebidasmezcalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Inspección durante el envasado') principalMap.push({ inspeccionduranteenvasado: rowspagina1[i].observaciones, inspeccionduranteenvasadocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Emisión del certificado NOM de exportación') principalMap.push({ emicioncertificadonomexportacio: rowspagina1[i].observaciones, emicioncertificadonomexportaciocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Emisión del certificado NOM para venta nacional') principalMap.push({ emicioncertificadonomnacional: rowspagina1[i].observaciones, emicioncertificadonomnacionalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Fecha propuesta de la actividad') principalMap.push({ fechavisitapropuesta: rowspagina1[i].observaciones, fechavisitapropuestacheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Venta nacional') principalMap.push({ ventanacional: rowspagina1[i].observaciones, ventanacionalcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Venta exportación') principalMap.push({ ventaexportacion: rowspagina1[i].observaciones, ventaexportacioncheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Nombre de importador') principalMap.push({ nombreimportador: rowspagina1[i].observaciones, nombreimportadorcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Domicilio del importador') principalMap.push({ domicilioimportador: rowspagina1[i].observaciones, domicilioimportadorcheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Pais destino') principalMap.push({ paisdestino: rowspagina1[i].observaciones, paisdestinocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Aduana salida') principalMap.push({ aduanasalida: rowspagina1[i].observaciones, aduanasalidacheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Observaciones') principalMap.push({ observaciones: rowspagina1[i].observaciones, observacionescheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let productosMap = []
        for (const producto of rowspagina2) {
            productosMap.push({ idfc41_anexoproductomap: producto.idfc41_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc41_anexoproducto: producto.idfc41_anexoproducto })
        }
        let archivosProductosMap = []
        for (const anexo in rowspagina3) {
            let nameid = rowspagina3[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAG" || nameid === "DPAB" || nameid === "DPFP" || nameid == "DPOC" || nameid == "DPCN" || nameid == "DPJE") {
                archivosProductosMap.push({
                    estatuscheck: rowspagina3[anexo]?.incorrecto, observacion: rowspagina3[anexo]?.observaciones,
                    idfc_41archivoproducto: rowspagina3[anexo]?.idfc_41archivoproducto, idfc_41archivoproductomap: rowspagina3[anexo]?.idMap
                })
            }
        }

        let archivosProductos = []
        for (const anexo in rowspagina3) {
            let nameid = rowspagina3[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAG" || nameid === "DPAB" || nameid === "DPFP" || nameid == "DPOC" || nameid == "DPCN" || nameid == "DPJE") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina3[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina3[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina3[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina3[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_41archivoproducto: rowspagina3[anexo]?.idfc_41archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosProductos: archivosProductos }
        let formatoMap = { solicitud: obj_unidos, productosMap: productosMap, archivosProductosMap: archivosProductosMap }
        await dispatch(actualizarFC_41MapSolicitud(formatoMap))
        await dispatch(actualizarFC_41Solicitud(formato))
        return
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>
                        <FormularioDocumentacionFC_41
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_41>
                        <br />

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_41Map) || JSON.stringify([]) === JSON.stringify(fc_41Map) || fc_41Map === null) {
            await agregarMapYActualizarFC_41()
        } else {
            await actualizarMapYActualizarFC_41()
        }
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        const detalle = await dispatch(obtenerFC_41SolicitudDetalle(solicitud.idfc41_solicitudparabebidasconm))
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "13", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud,
            numcertificadonom: dataForm?.numCertificadoNOM,
            numplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado,
            credelcialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        let actualizarinformacion = {
            idfc41_solicitudparabebidasconm: solicitud.idfc41_solicitudparabebidasconm,
            informacionmodalaceptada: informacionmodalaceptada
        }
        await dispatch(actualizarFC_41SolicitudModal(actualizarinformacion))

        await generarOficios(detalle.payload.data, dataCliente.payload.cliente[0], dataForm)
        const idSolicitud = solicitud.idfc41_solicitudparabebidasconm
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_41 = 12
        const tabla = tablaFC_41
        await dispatch(actualizarFC_41Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_41, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_41',
            solicitudFC_41,
            dataCliente,
        }
        let nacional = false
        let exportacion = false
        if (solicitud.emicioncertificadonomexportacio) exportacion = true
        if (solicitud.emicioncertificadonomnacional) nacional = true
        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: 'SOLICITUD PARA BEBIDAS CON MEZCAL',
            fechaInspeccion: solicitud.fechavisitapropuesta.substring(0, 10),
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: nacional,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: exportacion,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_41(data))
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_35())
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                <div className='row justify-content-center'>
                    <div className='col-10'>
                        <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                    </div>
                </div> :
                nombresParaPaginas[paginaActiva - 1] === 'Características de productos' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <div style={{ height: (130 + (rowspagina2?.length * 50)), width: '99%', color: 'black' }}>
                                <DataGrid
                                    rows={rowspagina2}
                                    columns={columns}

                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </div> : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                        <Fragment>
                            <div className='row justify-content-center'>
                                <div className='col-12' style={{ marginLeft: '7%' }}>
                                    <TablaDocumentacion rows={rowspagina3} api={{ handdleEditPrev }}></TablaDocumentacion>
                                </div>
                            </div>
                            {modoVerDetalle ?
                                <div className="row text-center">
                                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                        <button type="submit" className={`btn ${estilosFC41.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                    </div>
                                </div>
                                :
                                <div className="row text-center mt-4 mb-4">
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                        <button type="submit" className={`btn ${estilosFC41.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                    </div>

                                    <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                        <button type="submit" className={`btn ${estilosFC41.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                    </div>
                                </div>
                            }</Fragment> : ''
            }
            {modalComponentAceptar()}
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
            {modalComponentDevolver()}
            {detalleMarcas && <ModalDetalleProducto api={{ VerModalDetalle, dataDetalle, detalleMarcas }} />}
        </Fragment>
    )
}

export default withRouter(FC_41Component)
